import timeZones from './timeZones'
import convertTimeZoneOffsetToString from './convertTimeZoneOffsetToString'

let currentTimeZone: string | undefined

export default function getCurrentTimeZone(): string | undefined {
    if (!currentTimeZone) {
        const intlTimeZone = window.Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone
        if (intlTimeZone) {
            currentTimeZone = intlTimeZone
        } else {
            const tzOffsetString = convertTimeZoneOffsetToString(new Date().getTimezoneOffset())
            currentTimeZone = timeZones.find((tz) => tz.utc === tzOffsetString)?.code
        }
    }
    return currentTimeZone
}
